"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _format = _interopRequireDefault(require("date-fns/format"));
var _getKSADate = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/utils/store/getKSADate"));
var _getArabicMonthName = _interopRequireDefault(require("../getArabicMonthName"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Returns day, month & year for either
 * current date or passed DOB
 * @returns {Object}
 * eg. {
 *  day: '14',
 *  month: 'April',
 *  year: '2021'
 * }
 */
function getDayMonthYear() {
  var selectedDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var isRtl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var splitArr = [];
  if (selectedDate) {
    // for values coming from the text field
    // we have to persist in the DOB calendar
    splitArr = selectedDate.split('/'); // [date, month, year]
    // because month comes as number
    var formattedMonth = (0, _format["default"])(new Date(splitArr[2], splitArr[1] * 1 - 1, splitArr[0]), 'MMMM'); // eg. 'April'
    splitArr[1] = formattedMonth;
    // for arabic
    if (isRtl) {
      splitArr[1] = (0, _getArabicMonthName["default"])(formattedMonth);
    }
  } else {
    // for first time load, show default date, month, year
    var defaultYear = '1990';
    var currentDate = (0, _format["default"])((0, _getKSADate["default"])(new Date(defaultYear)), 'dd MMMM yyyy'); // 1 January 1990
    splitArr = currentDate.split(' ');
    // for arabic
    if (isRtl) {
      splitArr[1] = (0, _getArabicMonthName["default"])(splitArr[1]);
    }
  }
  return {
    cday: splitArr[0] * 1,
    // convert to number
    cmonth: splitArr[1],
    cyear: splitArr[2] * 1 // convert to number
  };
}
var _default = exports["default"] = getDayMonthYear;